import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/it/fondamenti')({
  component: Outlet,
})
